import { selectAll, getControllers } from './element-manipulation'

export const refreshBgImages = (element) => {
  selectAll(element, '[data-hook~="bgImage"]').forEach((bgImageElement) => {
    getControllers(bgImageElement).bgImage.apply()
  })
}
